import { render, staticRenderFns } from "./ModalCancelamentoAssincronos.vue?vue&type=template&id=2b41cbea&lang=pug"
import script from "./ModalCancelamentoAssincronos.vue?vue&type=script&lang=js"
export * from "./ModalCancelamentoAssincronos.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelamentoAssincronos.vue?vue&type=style&index=0&id=2b41cbea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports